import Grid from "@mui/material/GridLegacy";
import dynamic from "next/dynamic"
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const TypographyGridCol = dynamic(() => import("../Reusables/TypographyGridCol"));
const ContactSchema = dynamic(() => import("../Schemas/ContactUsSchema"));
const ContactInformation = dynamic(() => import("./ContactInformation"));
const ContactForm = dynamic(() => import("./ContactForm"));
const ContactDepotsMaps = dynamic(() => import("./ContactDepotsMaps"));



const ContactUs = (props) => {
    const {
        template_page_settings
    } = props;

    return (
        <BoxContainer template_page_settings={template_page_settings}>
            <ContactSchema />
            <Grid container>
                <TypographyGridCol
                    title="Contact Information"
                    subtitle="To contact us, please use the contact information shown below."
                >
                    <ContactInformation {...props} />
                </TypographyGridCol>

                <TypographyGridCol
                    title="Contact Form"
                    subtitle="Alternatively, please fill out the contact form and one of our team will get back to you as soon as possible."
                >
                    <ContactForm {...props} />
                </TypographyGridCol>
            </Grid>

            <ContactDepotsMaps {...props} />
        </BoxContainer>
    )
}

export default ContactUs